import { render, staticRenderFns } from "./xjt.vue?vue&type=template&id=99ad54a8&scoped=true"
import script from "./xjt.vue?vue&type=script&lang=js"
export * from "./xjt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ad54a8",
  null
  
)

export default component.exports